import React from 'react'

const Tooltip = ({ text, children, show = true }) => (
    <div className="relative group inline-block">
        {children}
        {show && (
            <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 hidden group-hover:block z-[999] bg-[#031624] text-white text-xs rounded-lg px-3 py-2 w-[200px] pointer-events-none">
                {text}
            </div>
        )}
    </div>
)

export default Tooltip
